import { INode } from 'shared/types/tree'
import { makeKiddomGetRequest } from 'infrastructure/api'
import { useCallback } from 'react'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'
import { normalizeNodes } from 'shared/utils/tree'

export async function getTree({
  treeId,
  versionId,
  depth = -1,
}: {
  treeId: string
  versionId: string
  depth?: number
}) {
  let kiddomPath = `/api/tree/${treeId}:${versionId}`
  if (depth !== -1) {
    kiddomPath += `?depth=${depth}`
  }

  const { result, error } = await makeKiddomGetRequest<INode>({ kiddomPath })
  if (result) normalizeNodes(result)
  return { result, error }
}

export function useGetTree() {
  const treeGetter = useWithErrorNotification(
    { errorTitle: 'Error Getting Tree' },
    getTree,
  )
  return useCallback(
    (params: { treeId: string; versionId: string; depth?: number }) => {
      return treeGetter(params)
    },
    [treeGetter],
  )
}
